export default __webpack_public_path__ + "static/media/rules-periodic-bg-desktop.cb6ce6b7.jpg";